import styled from 'styled-components';

import { Card } from '@xingternal/card';
import { mediaConfined } from '@xingternal/layout-tokens';
import {
  cornerRadiusM,
  spaceM,
  spaceS,
  xdlColorTextSecondary,
  xdlPaletteLime07,
  xdlPaletteMint06,
  xdlPaletteOrange07,
  xdlPaletteYellow07,
} from '@xingternal/tokens';
import { Headline } from '@xingternal/typography';

export const StyledCard = styled(Card)`
  &,
  &:hover,
  &:visited,
  &:focus {
    color: inherit;
    text-decoration: none;
  }
  margin-top: ${spaceM};
  padding: ${spaceM};

  @media ${mediaConfined} {
    margin-top: 0;
  }
`;

export const CardContainer = styled(StyledCard)`
  & > div {
    display: flex;
    flex-direction: row;
    flex: 2fr 8fr 1fr;
    justify-content: space-between;
    width: 100%;
  }
`;

const StatusColors = {
  low: xdlPaletteOrange07,
  medium: xdlPaletteYellow07,
  high: xdlPaletteLime07,
  completed: xdlPaletteMint06,
};

export const ScoreBar = styled.div`
  border-radius: ${cornerRadiusM};
  height: 4px;
  background-color: ${({ status }: { status: keyof typeof StatusColors }) => StatusColors[status]};
`;

export const ScoreContainer = styled.div`
  word-break: initial;
  display: flex;
`;

export const TextContainer = styled.div`
  padding-left: ${spaceM};
`;

export const ErrorContainer = styled(Card)`
  display: flex;
  flex-direction: row;
  color: ${xdlColorTextSecondary};
  cursor: pointer;
`;

export const Score = styled(Headline)`
  transform: translateY(${spaceS});
  margin-left: ${spaceS};
`;

export const Title = styled(Headline)`
  line-height: 1.5;
`;
